import { render } from "./VerifyLetters.vue?vue&type=template&id=0b842276&scoped=true"
import script from "./VerifyLetters.vue?vue&type=script&lang=js"
export * from "./VerifyLetters.vue?vue&type=script&lang=js"

import "./VerifyLetters.vue?vue&type=style&index=0&id=0b842276&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b842276"]])

export default __exports__